export enum RoleAssistantFabState {
  none,
  assistanceReadyToBeConfirmed,
  assistanceReadyToStart,
  assistanceReadyToEnd,
  assistanceFinished,
  working,
}

export class RoleAssistantFab {
  states = {
    [RoleAssistantFabState.none]: true,
    [RoleAssistantFabState.assistanceReadyToBeConfirmed]: false,
    [RoleAssistantFabState.assistanceReadyToStart]: false,
    [RoleAssistantFabState.assistanceReadyToEnd]: false,
    [RoleAssistantFabState.assistanceFinished]: false,
    [RoleAssistantFabState.working]: false,
  }

  public set(state: RoleAssistantFabState) {
    for (const s in this.states) {
      if (this.states.hasOwnProperty(s)) {
        this.states[s] = false
      }
    }

    this.states[state] = true
  }
}
